import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SignupDeclarationFormGroup } from '../interfaces/forms/signup-declaration-form.interface';

@Injectable({
  providedIn: 'root',
})
export class SignupDeclarationFormService {
  public readonly fb = inject(FormBuilder);

  public formGroup: SignupDeclarationFormGroup;

  public initFormGroup(): SignupDeclarationFormGroup {
    this.formGroup = this.fb.group({
      acceptAccountDeclaration: new FormControl(false, [Validators.requiredTrue]),
    });

    return this.formGroup;
  }
}
